var map = {
	"./applepay_2024_10_23.svg": 1091,
	"./bancontact_2024_10_23.svg": 1092,
	"./belfius.svg": 1093,
	"./biller.svg": 1094,
	"./billie_2024_10_23.svg": 1095,
	"./blik.svg": 1096,
	"./bnpl-light.svg": 1097,
	"./buyer_associations/prisma.avif": 1098,
	"./buyer_associations/soennecken.svg": 1099,
	"./cartes_bancaires_2024_10_23.svg": 1100,
	"./creditcard.svg": 1101,
	"./eps.svg": 1102,
	"./giropay.svg": 1103,
	"./hokodo_2024_10_23.svg": 1104,
	"./ideal_2024_10_23.svg": 1105,
	"./inghomepay.svg": 1106,
	"./kbc.svg": 1107,
	"./mastercard.svg": 1108,
	"./mobilepay.svg": 1109,
	"./mondu.svg": 1110,
	"./paypal_2024_10_23.svg": 1111,
	"./przelewy24.svg": 1112,
	"./sepa_2024_10_23.svg": 1113,
	"./sofort.svg": 1114,
	"./supplier_authorization.svg": 1115,
	"./test.svg": 1116,
	"./visa.svg": 1117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 832;